import { makeStyles } from '@fluentui/react';
import {
  BRANCH_NODE_HEIGHT,
  BRANCH_NODE_WIDTH,
  CONDITION_NODE_HEIGHT,
  CONDITION_NODE_WIDTH,
  LEVEL_NODE_HEIGHT,
  LEVEL_NODE_WIDTH,
} from './constants';
export const useStyles = makeStyles((theme) => ({
  container: {
    height: 'calc(100vh - 50px)',
    zIndex: 100,
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: theme.palette.white,
  },
  mainContainer: {
    paddingTop: 70,
    flexDirection: 'row',
    flex: 1,
    display: 'flex',
    width: '100%',
  },
  sidebarContainer: {
    // width: 100,
    paddingTop: 50,
    // gridGap: '20px',
    height: '100vh',
    // border: '1px solid black',
    minHeight: 500,
    backgroundColor: theme.palette.neutralLighterAlt,
    // height: '100%',
  },
  bodyContainer: {
    flex: 1,
    paddingTop: 50,
    // paddingLeft: 20,
  },
  bodyContainerAlternative: {
    paddingTop: 0,
  },
  // Sidebar Styles
  menuItem: {
    cursor: 'pointer',
    gridGap: '10px',
    // backgroundColor: theme.palette.neutralLighter,
    padding: '30px 40px',
    maxWidth: 300,
    // borderRadius: 5,
    ':hover': {
      backgroundColor: `${theme.palette.neutralLight}8D`,
    },
  },
  menuItemIcon: {
    color: theme.palette.neutralDark,
    fontSize: 28,
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'center',
  },

  // Approval Node styles
  approvalNodeContainer: {
    height: CONDITION_NODE_HEIGHT,
    width: CONDITION_NODE_WIDTH,
    border: `1px solid ${theme.palette.neutralQuaternary}`,
    // padding: 20,
    backgroundColor: theme.palette.neutralLighterAlt,
    borderRadius: 5,
    transition: 'all 0.3s ease',
    ':hover': {
      border: `1px solid ${theme.palette.themePrimary}`,
    },
  },
  levelNodeContainer: {
    height: LEVEL_NODE_HEIGHT,
    width: LEVEL_NODE_WIDTH,
    border: `2px solid ${theme.palette.neutralQuaternary}`,
    backgroundColor: theme.palette.neutralLighterAlt,
    borderRadius: 7,
    transition: 'all 0.1s ease',
    ':hover': {
      borderRadius: 8,
      border: `3px solid ${theme.palette.themePrimary}`,
    },
  },
  levelBranchesNodeContainer: {
    height: BRANCH_NODE_HEIGHT,
    width: BRANCH_NODE_WIDTH,
    border: `1px solid ${theme.palette.neutralQuaternary}`,
    backgroundColor: theme.palette.neutralLighterAlt,
    borderRadius: 7,
    transition: 'all 0.1s ease',
    ':hover': {
      borderRadius: 8,
      border: `3px solid ${theme.palette.themePrimary}`,
    },
  },
  approvalNodeHeader: {
    width: '100%',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    padding: '5px 10px',
    backgroundColor: theme.palette.white,
    borderBottom: `1px solid ${theme.palette.neutralQuaternary}`,
  },
  approvalLevelNodeHeader: {
    width: '100%',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    padding: '5px 10px',
    backgroundColor: theme.palette.themePrimary,
    borderBottom: `1px solid ${theme.palette.neutralQuaternary}`,
  },
  approvalBranchNodeHeader: {
    width: '100%',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    padding: '5px 10px',
    backgroundColor: theme.palette.white,
    borderBottom: `1px solid ${theme.palette.neutralQuaternary}`,
  },
  approvalNodeTitle: {
    // width: 90,
    flexDirection: 'row',
    display: 'flex', // key line
    padding: '2px 6px', 
    borderRadius: 3,
  },

  AddApprovalCallout: {
    minWidth: 550,
    width: 400,
    maxHeight: 500,
    overflow: 'hidden',
    backgroundColor: theme.palette.neutralLighterAlt,
    // customScroll: {
    //   flex: 1,
    //   overflow: 'scroll',
    //   '::-webkit-scrollbar': {
    //     width: 5,
    //   },
    //   '::-webkit-scrollbar-thumb': {
    //     backgroundColor: theme.palette.neutralLight,
    //     borderRadius: '6px',
    //     // width: 5,
    //   },
    //   '::-webkit-scrollbar-thumb:hover': {
    //     backgroundColor: theme.palette.neutralLighter,
    //   },
    // },
  },
  // AddApprovalCalloutContainer: {
  //   padding: '20px',
  //   backgroundColor: theme.palette.neutralLighterAlt,
  // },

  addNode: {
    width: 300,
    height: 80,
    borderRadius: 5,
    cursor: 'pointer',
    color: theme.palette.neutralDark,
    border: `1px dashed ${theme.palette.neutralDark}`,
    // backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23333' stroke-width='1' stroke-dasharray='6' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: '100% 100%',
    backgroundColor: `${theme.palette.neutralLight}77`,
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: `${theme.palette.themePrimary}11`,

      color: theme.palette.themePrimary,
      border: `1px dashed ${theme.palette.themePrimary}`,
    },
  },
}));
